import { render } from "./NavItem.vue?vue&type=template&id=ff2a80f6&scoped=true&ts=true"
import script from "./NavItem.vue?vue&type=script&lang=ts"
export * from "./NavItem.vue?vue&type=script&lang=ts"

import "./NavItem.vue?vue&type=style&index=0&id=ff2a80f6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff2a80f6"]])

export default __exports__